import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { PipesModule } from '../../pipes';
import { CardHorizontalTreeComponent } from './card-horizontal-tree/card-horizontal-tree.component';
import { CardComponent } from './card.component';
import { HorizontalLayerComponent } from './horizontal-layer/horizontal-layer.component';

@NgModule({
    declarations: [CardComponent, HorizontalLayerComponent, CardHorizontalTreeComponent],
    imports: [CommonModule, FormsModule, TwcModule, TranslateModule, PipesModule],
    exports: [CardComponent],
})
export class CardModule {}
